import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum ScheduleApplicationsViewColumn {
    DATE = "date",
    TEMPLATE = "template",
    GROUP = "group",
    TYPE = "type",
    REFERENCE = "reference",
    DESCRIPTION = "description",
    LINE_ITEM = "lineItem",
    COUNTERPARTY = "counterparty",
    CLASS = "class",
    SPLIT = "split",
    AMOUNT = "amount",
    REMAINING_BALANCE = "remainingBalance",
    MATCH = "match",
    ENTITY = "entity",
    STATUS = "status",
    ACTIONS = "actions",
}

const makeColumnSchema = (id: ScheduleApplicationsViewColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const ScheduleApplicationsViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.SCHEDULE_APPLICATIONS),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(ScheduleApplicationsViewColumn.DATE),
            makeColumnSchema(ScheduleApplicationsViewColumn.TEMPLATE),
            makeColumnSchema(ScheduleApplicationsViewColumn.GROUP),
            makeColumnSchema(ScheduleApplicationsViewColumn.TYPE),
            makeColumnSchema(ScheduleApplicationsViewColumn.REFERENCE),
            makeColumnSchema(ScheduleApplicationsViewColumn.DESCRIPTION),
            makeColumnSchema(ScheduleApplicationsViewColumn.LINE_ITEM),
            makeColumnSchema(ScheduleApplicationsViewColumn.COUNTERPARTY),
            makeColumnSchema(ScheduleApplicationsViewColumn.CLASS),
            makeColumnSchema(ScheduleApplicationsViewColumn.SPLIT),
            makeColumnSchema(ScheduleApplicationsViewColumn.AMOUNT),
            makeColumnSchema(ScheduleApplicationsViewColumn.REMAINING_BALANCE),
            makeColumnSchema(ScheduleApplicationsViewColumn.MATCH),
            makeColumnSchema(ScheduleApplicationsViewColumn.ENTITY),
            makeColumnSchema(ScheduleApplicationsViewColumn.STATUS),
            makeColumnSchema(ScheduleApplicationsViewColumn.ACTIONS),
        ]),
    ),
});

export type ScheduleApplicationsView = z.infer<
    typeof ScheduleApplicationsViewSchema
>;
